import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import "./css/myteam.css";

function Myteam() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;

  const { setGlobalLoading, token } = useOutletContext();

  const [employees, setEmployees] = useState([]);
  const foptions = useRef();
  const navigate = useNavigate();

  /*
   * ============================================================
   * FETCH TEAM
   * ============================================================
   */

  const fetchOptions = async () => {
    setGlobalLoading(true);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/employeeinfos/get_team_list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setEmployees(response.data?.team_list || []);
      console.log(response.data.team_list);
    } catch (error) {
      console.error("API Error:", error);
      setEmployees([]);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (foptions.current) return;

    foptions.current = true;
    fetchOptions();
  }, []);

  /*
   * ============================================================
   * EMPLOYEE IMAGE
   * ============================================================
   *
   * Change this path if your employee image API path is different.
   */

  const getEmployeeImage = (employee) => {
    if (!employee.userpic) {
      return "/assets/img/profiles/avatar-02.jpg";
    }

    if (
      employee.userpic.startsWith("http://") ||
      employee.userpic.startsWith("https://")
    ) {
      return employee.userpic;
    }

    return `${PINE_BASE_URL}/files/media/${employee.userpic}`;
  };

  /*
   * ============================================================
   * EMPLOYEE CLICK
   * ============================================================
   *
   * Change this URL according to your existing employee details
   * route.
   */

  const handleEmployeeClick = (employee) => {
    navigate(`/personalinfo/teamview/${employee.user_id}`);
  };

  /*
   * ============================================================
   * BUILD TREE
   * ============================================================
   */

  const buildTree = () => {
    const employeeMap = new Map();

    employees.forEach((employee) => {
      employeeMap.set(Number(employee.user_id), {
        ...employee,
        children: [],
      });
    });

    const roots = [];

    employees.forEach((employee) => {
      const employeeNode = employeeMap.get(Number(employee.user_id));

      const parentId = Number(employee.parent_id || 0);

      if (parentId && employeeMap.has(parentId)) {
        employeeMap.get(parentId).children.push(employeeNode);
      } else {
        roots.push(employeeNode);
      }
    });

    return roots;
  };

  const tree = buildTree();

  /*
   * ============================================================
   * EMPLOYEE CARD
   * ============================================================
   */

  const EmployeeCard = ({ employee }) => {
    return (
      <div className="org-node">
        <div
          className="employee-card"
          onClick={() => handleEmployeeClick(employee)}
          title={`View ${employee.employee}`}
        >
          <div className="employee-image-wrapper">
            <img
              src={getEmployeeImage(employee)}
              alt={employee.employee}
              className="employee-image"
              onError={(e) => {
                e.currentTarget.src =
                  "/assets/img/profiles/avatar-02.jpg";
              }}
            />
          </div>

          <div className="employee-name">
            {employee.employee}
          </div>

          <div className="employee-designation">
            {employee.designation || "N/A"}
          </div>

          {employee.location && (
            <div className="employee-location">
              {employee.location || "N/A"}
            </div>
          )}
        </div>

        {employee.children?.length > 0 && (
          <div className="children-wrapper">
            {employee.children.map((child) => (
              <EmployeeCard
                key={child.user_id}
                employee={child}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="content">
      <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <div className="my-auto mb-2">
          <h2 className="mb-1">My Team</h2>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="organization-chart-container">
            {tree.length > 0 ? (
              <div className="organization-chart">
                {tree.map((employee) => (
                  <EmployeeCard
                    key={employee.user_id}
                    employee={employee}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-5">
                <h5>No team members found</h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Myteam;